import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import moment from "moment";
import Swal from "sweetalert2";
import DateAndTimePickerNotification from "../DateAndTimePicker/notificationDateTimePicker";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "10px",
  border: "none",
  boxShadow: 24,
  p: 4,
};

function isHTML(str) {
  const doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}

const ValidDateEditor = ({ record, handleUpdate }) => {
  const [validFrom, setValidFrom] = useState(record?.valid_from || null);
  const [validTo, setValidTo] = useState(record?.valid_to || null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setValidFrom(record?.valid_from);
    setValidTo(record?.valid_to);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (open && record) {
      // When modal opens, reset values
      setValidFrom(record?.valid_from);
      setValidTo(record?.valid_to);
    }
  }, [open, record]);

  const onSave = async () => {
    try {
      await handleUpdate(record.id, record.title, {
        validFrom: validFrom ? new Date(validFrom) : null,
        validTo: validTo ? new Date(validTo) : null,
      });

      // ✅ Close modal after success
      setOpen(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message,
      });
    }
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <p style={{ padding: "8px" }}>
          {(() => {
            const from = record.valid_from
              ? moment(record.valid_from).format("DD/MM/YYYY")
              : null;
            const to = record.valid_to
              ? moment(record.valid_to).format("DD/MM/YYYY")
              : null;

            if (from && to) return `${from} - ${to}`;
            if (from && !to) return `From ${from}`;
            if (!from && to) return `Till ${to}`;
            return "-"; // both empty
          })()}
        </p>

        <div className="btn" onClick={handleOpen}>
          <i className="ri-edit-2-line" data-toggle="tooltip" title="Edit"></i>
        </div>
      </div>

      <Modal open={open} onClose={handleClose} sx={{ border: "none" }}>
        <Box sx={style}>
          {/* 🔹 Title Section */}
          {isHTML() ? (
            <h4
              style={{ fontWeight: "bold", marginBottom: "20px" }}
              dangerouslySetInnerHTML={{ __html: record.english_title }}
            />
          ) : (
            <h4 style={{ fontWeight: "bold", marginBottom: "20px" }}>
              {record.title}
            </h4>
          )}

          {/* 🔹 Form Section */}
          <form className="input_form">
            <div className="row">
              {/* Valid From */}
              <div className="col-lg-12 col-md-6 col-sm-6 col-6">
                <div className="fieldrow">
                  <label className="f_label"> Valid From</label>

                  <DateAndTimePickerNotification
                    required
                    value={validFrom}
                    setValue={(e) => {
                      setValidFrom(e);
                      setValidTo(null);
                    }}
                    min={moment(new Date()).format("YYYY-MM-DD")}
                    type="date"
                    className="f_input"
                  />
                </div>
              </div>

              {/* Valid To */}
              <div className="col-lg-12 col-md-6 col-sm-6 col-6">
                <div className="fieldrow">
                  <label className="f_label">Valid To</label>
                  <DateAndTimePickerNotification
                    required
                    value={validTo}
                    setValue={(e) => setValidTo(e)}
                    min={moment(validFrom).format("YYYY-MM-DD")}
                    type="date"
                    className="f_input"
                  />
                </div>
              </div>
            </div>

            {/* 🔹 Action Button */}
            <div
              style={{
                display: "flex",
                justifyContent: "right",
                marginTop: "10%",
              }}
            >
              <Button variant="contained" onClick={onSave}>
                Save
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default ValidDateEditor;
